import { axios } from '@/utils/request'
// import moment from 'moment'

const api = {
  trial: '/product/trial/trial',
  sendProduct: '/product/trial/sendProduct',
  rpaAuth: '/CallFunc.aom',
  exportExcel: '/product/trial/trial/export'
}

export default api
// 新闻类型
export function getTrial(params) {
  return axios({
    url: api.trial,
    method: 'get',
    params
  })
}

export function deleteTrial(params) {
  return axios({
    url: api.trial,
    method: 'delete',
    params
  })
}

export function sendProduct(params) {
  return axios({
    url: api.sendProduct,
    method: 'get',
    params
  })
}

/**
 *
 * RPA 产品授权
 */
// const RPA_URL = 'http://10.10.2.27:52955'

export function rpaAuth(data) {
  return axios({
    baseURL: '/CallFunc.aom',
    // url: api.rpaAuth,
    headers: {
      'Content-Type': 'application/json'
    },
    method: 'post',
    data
  })
}

export function exportExcel(params) {
  return axios({
    url: api.exportExcel,
    method: 'get',
    params,
    timeout: 1000 * 60 * 30,
    reponseOriginal: true,
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json; charset=utf-8',
      withCredentials: true
    },
    responseType: 'blob'
  }).then(res => {
    const content = res.data
    const blob = new Blob([content], { type: 'application/octet-stream' })
    const cd =
      res.headers['Content-disposition'] ||
      res.headers['content-disposition'] ||
      res.headers['Content-Disposition']
    const fileName = window.decodeURI((cd || '').split('=')[1], 'UTF-8')

    // const prefix = '导出报表'
    // const subfix = moment().format('YYYY-MM-DD')
    // const fileName = `${prefix}-${subfix}.xls`
    if (typeof window.navigator.msSaveBlob !== 'undefined') {
      // 兼容IE，window.navigator.msSaveBlob：以本地方式保存文件
      window.navigator.msSaveBlob(blob, fileName)
    } else {
      // 创建新的URL并指向File对象或者Blob对象的地址
      const blobURL = window.URL.createObjectURL(blob)
      // 创建a标签，用于跳转至下载链接
      const tempLink = document.createElement('a')
      tempLink.href = blobURL
      tempLink.setAttribute('download', fileName)
      // 兼容：某些浏览器不支持HTML5的download属性
      if (typeof tempLink.download === 'undefined') {
        tempLink.setAttribute('target', '_blank')
      }
      tempLink.click()
      // 释放blob URL地址
      window.URL.revokeObjectURL(blobURL)
    }
  })
}
